export default "__VITE_ASSET__Cp1nbYfv__"